import {Button} from 'platform/components';

import {useDispatch} from 'react-redux';

import {salesApi} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

export function AdvertisementPreviewRefreshAction(props: {vehicleId: string}) {
  const dispatch = useDispatch();

  const handleRefresh = () => {
    dispatch(
      salesApi.util.invalidateTags([
        {type: 'Vehicle', id: props.vehicleId},
        {type: 'AdGeneralSettings', id: props.vehicleId},
        {type: 'VehicleLocalizedContent', id: props.vehicleId},
      ])
    );
  };

  return (
    <Button
      variant="link"
      title={i18n.t('general.actions.refresh')}
      leftIcon="navigation/refresh"
      onClick={handleRefresh}
      data-testid={testIds.vehicles.publishing('advertisement-preview-refresh')}
    />
  );
}
